import React from 'react';
import { Box } from '@mui/material';

import { consoleTokens } from './consoleTokens';

/** Keyboard-shortcut chip (⌘K, G, E). An affordance, not a button. */
export const Kbd: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box
    component="kbd"
    sx={{
      alignItems: 'center',
      bgcolor: consoleTokens.tokenBg,
      border: `1px solid ${consoleTokens.line}`,
      borderBottomWidth: 2,
      borderRadius: '4px',
      color: consoleTokens.dim,
      display: 'inline-flex',
      fontFamily: consoleTokens.mono,
      fontSize: '0.6875rem',
      height: 18,
      justifyContent: 'center',
      minWidth: 18,
      px: 0.5,
    }}
  >
    {children}
  </Box>
);
